module.exports = __webpack_public_path__ + "img/submit.52b84a4c.png";